export enum ModalType {
  Archive,
  AddToGroup,
  MoveToGroup,
  AddGroupUser,
  RemoveGroupMember,
}
